// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CY-1W","contentContainer":"styles_contentContainer__1ySpC"};